import "../../global/advert-card-container.ts"
import "./show-results-button"
import "./category-checkboxes"
import "./city-addresses-select"
import "./distance-select"
import "./filter-bar"
import "./filter-checkboxes"
import "./filter-tabs"
import "./location-input"
import "./location-links"
import "./searchtext"
import "./filter-clear-button"

$("#fltCont").on("shown.bs.modal", () => {
    document.documentElement.style.overflow = "hidden"
})

$("#fltCont").on("hidden.bs.modal", () => {
    document.documentElement.style.overflow = "auto"
})
